/*
 * @Descripttion: 
 * @version: 1.0
 * @Author: hayuu
 * @Date: 2024-09-09 09:56:55
 * @LastEditors: hayuu
 * @LastEditTime: 2025-04-01 18:44:50
 */
import request from '@/utils/request'
import { encryptECB, } from "@/utils/aes";

// 登录方法
/** 地市 -- 保德(暂时废弃) */
// export function login(loginNo, password, vcode, vcodeId, usertype) {
//   let api = '/loginApi'
//   return request({
//     url: api + '/gsp/uc10002',
//     headers: {
//       isToken: false,
//       repeatSubmit: false
//     },
//     method: 'post',
//     data: {
//       txnCommCom: {},
//       txnBodyCom: {
//         loginNo: loginNo,
//         loginPassword: encryptECB(password),
//         vcode: vcode,
//         vcodeId: vcodeId,
//         loginType: "AU01",
//         acctType: usertype,
//       }
//     }
//   })
// }
export function login(loginNo, password, vcode, vcodeId, usertype) {
  return request({
    /** 地市 -- 其他 */
    // url: '/auth/sxzwAuth/login',
    /** 地市 -- 保德 */
    url: '/auth/sxzwAuth/loginV2',
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    data: { loginNo, password, vcode, vcodeId, usertype }
  })
}


/** 地市 -- 保德(暂时废弃) */
// export function loginByPhone(userType, username, smscode) {
//   let api = '/loginApi'
//   return request({
//     url: api + '/gsp/uc11002',
//     headers: {
//       isToken: false,
//       repeatSubmit: false
//     },
//     method: 'post',
//     data: {
//       txnCommCom: {},
//       txnBodyCom: {
//         loginType: "AU09",
//         acctType: userType,
//         msgCode: smscode,
//         userMobile: username,
//       }
//     }
//   })
// }
/** 地市 -- 其他 */
export function loginByPhone(userType, username, smscode) {
  return request({
    url: '/auth/sxzwAuth/loginByPhoneV2',
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    data: { userType, username, smscode }
  })
}

// 注册方法
export function register(data) {
  return request({
    url: '/auth/register',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 刷新方法
export function refreshToken() {
  return request({
    url: '/auth/refresh',
    method: 'post'
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/system/user/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'delete'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/code',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}